<template>
  <client-only>
    <section class="py-24" id="mapSection">
      <h2 class="mb-16 heading-4-bd ">Trip Map</h2>
      <div class="relative">
        <div id="map" ref="mapDiv" class="img-cover" v-if='!isBot'/>
        <div class="map__note">
          <div class="flex">
            <p class="fw-700">{{`${mapNote?.destinations?.includes(" and ") ? "Destinations" : "Destination"}:`}}</p>
            <p class="text-detail">{{mapNote?.destinations}}</p>
          </div>
          <div class="flex">
            <p class="fw-700">Start:</p>
            <p class="text-detail">{{mapNote?.start}}</p>
          </div>
          <div class="flex">
            <p class="fw-700">Finish:</p>
            <p class="text-detail">{{mapNote?.end}}</p>
          </div>
        </div>
      </div>
    </section>
  </client-only>
</template>

<script setup>
import { ref, watch, reactive, onMounted } from 'vue'
import { Loader } from '@googlemaps/js-api-loader'
import MapStyle from './MapStyle.json'
import { assetCDN } from '~/helper'

const ASSETS_CDN = assetCDN()

// export default {
//   name: 'SectionMap',
  const props = defineProps({
    locations: {
      type: Array,
      default: () => [ // Dummy data, remove when API called
        {
          "name": "Ngon Villa Restaurant",
          "long": -122.214897,
          "lat": 37.772323,
          "day": 1,
          "ordering": 1
        },
        {
          "name": "Khong Ngon Villa Restaurant",
          "long": -157.821856,
          "lat": 21.291982,
          "day": 2,
          "ordering": 2
        },
        {
          "name": "Qua Ngon Villa Restaurant",
          "long": 178.431,
          "lat": -18.142599,
          "day": 3,
          "ordering": 3
        },
        {
          "name": "Qua Ngon Villa Restaurant",
          "long": 153.027892,
          "lat": -27.46758,
          "day": 3,
          "ordering": 3
        },
      ]
    },
    mapNote: {
      type: Object,
      default: () => {}
    }
  })
  // setup(props) {
    const API_KEY = useAppConfig().siteKeyGoogleMapJsAPI || ''
    const isBot = ref(false)
    const loader = ((process.client) && !isBot.value) ? new Loader({ apiKey: API_KEY }) : ''
    const mapDiv = ref(null)
    const headPoints = reactive([])
    const markers = reactive([])

    watch(() => props.locations, (locations) => {
      console.debug('locations', locations)
    })

    const initMap = async(locations) => {
      if(process.server) return
      if (locations && locations.length) {
        headPoints.push(locations[0])
        headPoints.push(locations[locations.length - 1])
      }

      await loader.load()

      const mapOptions = {
        styles: MapStyle,
        // disableDefaultUI: true, // a way to quickly hide all controls
        mapTypeControl: false,
        // zoomControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false
      }

      let bounds = new google.maps.LatLngBounds()
      let lineCoordinates = []
      let map
      
      if(mapDiv.value) {
         map = new google.maps.Map(mapDiv.value, mapOptions)

        if (locations) {
          locations.map((item) => {
            lineCoordinates.push(new google.maps.LatLng(item.lat, item.long))
          })
        }
      }
      

      // Init line
      // new google.maps.Polyline({
      //   path: lineCoordinates,
      //   strokeColor: '#5C5C5C',
      //   geodesic: true,
      //   strokeOpacity: 1.0,
      //   strokeWeight: 3,
      //   map: map,
      // })

      let image = {
        // url: require('@/assets/icons/start-point.svg'),
        url: `${ASSETS_CDN}/icons/start-point.svg`,
        scaledSize: new google.maps.Size(25, 35), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        // scale: 5,
      }

      const icon = {
        //url: require('@/assets/icons/marker.svg'),
        url: `${ASSETS_CDN}/icons/marker.svg`,
        origin: new google.maps.Point(0, 0),
        scaledSize: new google.maps.Size(18, 18)
      }

      const infoWindow = new google.maps.InfoWindow();
      let activeMarker;

      if (headPoints.length) {
        locations.forEach((item, key) => {
          if (key === headPoints.length - 1) {
            // image.url = require('@/assets/icons/end-point.svg')
            image.url = `${ASSETS_CDN}/icons/end-point.svg`
          }
          //console.log(item.name, item)
          let pos = { lat: item.lat, lng: item.long }
          let marker = new google.maps.Marker({
            position: pos,
            map,
            icon: key !== 0 && key !== locations.length - 1 ? icon : image,
            title: item.name,
            optimized: true,
            zIndex: (locations.length - key)
          })

          bounds.extend(pos)

          // Add a click listener for each marker, and set up the info window.
          marker.addListener('click', () => {
            infoWindow.close();

            if (activeMarker) {
              let p1 = activeMarker.getPosition()
              let p2 = marker.getPosition()

              if ((p1.lat() == p2.lat()) && (p1.lng() == p2.lng())) {
                activeMarker = null
                return ;
              }
            }

            infoWindow.setContent(marker.getTitle());
            infoWindow.open(marker.getMap(), marker);
            activeMarker = marker
          });

          markers.push(marker)
        })
      }

      // zoom option not working with fitBounds
      //let zoom = locations.length > 1 ? 15 : 10

      if (locations.length <= 1) {
        if (0 < locations.length) {
          map.setCenter({
            lat: locations[0].lat,
            lng: locations[0].long
          })
        }
        map.setZoom(15)
      } else {
        map.fitBounds(bounds)
      }

      map.addListener("click", () => {
        infoWindow.close()
        activeMarker = null
      });

      infoWindow.addListener('closeclick', ()=>{
        activeMarker = null
      });

      /*
      let listener = google.maps.event.addListener(map, "idle", function() {
          if (map.getZoom() > 10) map.setZoom(10);
          google.maps.event.removeListener(listener);
      });
      */
    }

    onMounted(async () => {
      isBot.value = window.IS_BOT === 1
      // init map
      await initMap(props.locations)
    })

//     return { mapDiv }
//   },
// }
</script>

<style lang="scss">
#map {
  width: 100%;
  height: 424px;
  border-radius: 12px 12px 0 0;
  // Make IOS map border radius
  .gm-style {
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    &-iw-tc{
      &::after {
        background: #000;
      }
    }
  }
}
.gm-style .gm-style-iw-c {
  background: #000;
  border-radius: 5px;
  padding: 12px !important;
  box-shadow: none;
}
.gm-style .gm-style-iw-d {
  overflow: hidden !important;
  max-height: 100% !important;
  font-weight: 700; font-family: $font-family-base;
  color: #fff;
}
.gm-style .gm-style-iw-t::after {
  background: #000;
  height: 10px;
  width: 10px;
  box-shadow: none;
}
@include phone {
  #map {
    height: 400px;
  }
}
.map__note {
  display: flex;
  gap: 10px 0;
  flex-direction: column;
  background: rgba(241, 241, 241, 0.5);
  min-height: 150px;
  padding: 30px;
  border-radius: 0 0 12px 12px;

  .flex {
    p {
      margin: 0
    }

    .fw-700 {
      flex: 0 0 110px;
    }
  }
}
// W7 dark: the map-note footer's rgba(241,241,241,.5) light literal doesn't flip → stayed a pale panel under the map with the (foreground-flipped) white Destination/Start/Finish text at poor contrast. Dark surface band so the inherited $foreground text reads. Light untouched. (The map tiles themselves are a Google render styled by MapStyle.json — not seam-controlled — and the .gm-style info-window is an intentionally black tooltip; both left as-is.)
[data-theme='dark'] .map__note {
  background: $surface-warm;
}
</style>
